module.exports = [{
      plugin: require('../node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":800,"quality":80},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
